export default {
  getBatchPrintingVerification: (state) => state.batchPrintingVerification,
};
